<template>
  <tiles-page
    title="Справочник"
    :link-groups="linksGroups"
    sm="12"
    md="6"
    xl="4"
  />
</template>

<script>
  import TilesPage from '@/components/ui/TilesPage.vue'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'
  import RouteName from '@/models/enums/RouteName'

  export default {
    components: { TilesPage },
    data () {
      return {
        linksGroups: [
          {
            title: 'Рестораны',
            links: [
              {
                icon: 'building',
                cols: 6,
                routeName: RouteName.Organizations,
                title: 'Организации (юр-лица)',
              },
              { icon: 'globe-europe', cols: 6, routeName: RouteName.Regions, title: 'Регионы' },
              { icon: 'store', cols: 12, routeName: RouteName.Branches, title: 'Филиалы' },
              /* {
                icon: 'users',
                cols: 6,
                routeName: RouteName.Staff,
                title: 'Сотрудники',
                permissions: [CRMPermission.ViewUsers],
              }, */
            ],
          },
          {
            title: 'Меню',
            links: [
              { icon: 'utensils', cols: 6, routeName: RouteName.Menu, title: 'Меню (каталог)' },
              {
                icon: 'tags',
                cols: 6,
                routeName: RouteName.PriceLists,
                title: 'Прайс-листы',
              },
              {
                icon: 'th-large',
                cols: 12,
                routeName: RouteName.Categories,
                title: 'Категории',
              },
            ],
          },
          {
            title: 'Контент',
            links: [
              {
                icon: 'layer-group',
                cols: 6,
                routeName: RouteName.Collections,
                title: 'Подборки',
              },
              { icon: 'newspaper', cols: 6, routeName: RouteName.News, title: 'Новости' },
              {
                icon: 'images',
                cols: 6,
                routeName: RouteName.Slider,
                title: 'Главный слайдер',
              },
              { icon: 'percent', cols: 6, routeName: RouteName.Promotions, title: 'Акции' },
            ],
          },
          {
            title: 'Состав блюд',
            links: [
              {
                icon: 'file-alt',
                cols: 6,
                routeName: RouteName.TechnicalCards,
                title: 'Технические карты',
              },
              {
                icon: 'sliders-h',
                cols: 6,
                routeName: RouteName.Modifications,
                title: 'Модификаторы',
              },
            ],
          },
          {
            title: 'Доставка',
            links: [
              {
                icon: 'map-marked-alt',
                cols: 12,
                routeName: RouteName.DeliveryZones,
                title: 'Зоны доставки и тарифы',
              },
            ],
          },
          {
            title: 'Промо',
            links: [
              {
                icon: 'ticket-alt',
                cols: 6,
                routeName: RouteName.Promocodes,
                title: 'Промокоды',
              },
              {
                icon: 'envelope-open-text',
                cols: 6,
                soon: true,
                title: 'Шаблоны рассылок',
              },
            ],
          },
        ],
      }
    },
  }
</script>
